import React, { memo } from 'react';
import classnames from 'classnames/bind';
import { Logo } from '@miroculus/nucleo';
import styles from './Spinner.scss';
const cx = classnames.bind(styles);
const Spinner = memo(() => (React.createElement("div", { className: cx('overlay') },
    React.createElement("div", { className: cx('container') },
        React.createElement(Logo, { color: "white", blueGradient: true, animated: true, infinite: true })))));
export default Spinner;
